import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  CardHeader,
  Button,
  Table
} from "reactstrap";

import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../config";
import RequestManager from "../../singletons/RequestManager";
import LoadingOverlay from "react-loading-overlay";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
export default class OrderBookingDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      endDate: moment(),
      loading: false,
      loadingValue: "Please Wait a moment, loading",
      merchants: null,
      stores: null,
      storeIds: [],
      selectedOrdersText: "Shows Booking Orders",
      ordersCount: 0,
      spinnerLoading: false
    };
  }

  componentWillMount() {
    this.checkLoginMode();
  }
  componentDidMount() {
    document
      .getElementsByTagName("input")[0]
      .setAttribute("readonly", "readonly");
  }
  getOrders = async bookingDateSelect => {
    this.setState({
      orders: [],
      grandTotal: 0.0,
      loadingValue: "Please Wait a moment, loading",
      loading: false,
      spinnerLoading: true
    });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }
    console.log("params", params);
    let requestManager = new RequestManager();

    let query;

    query = "getOrderHistoryBookingOrders";

    console.log(params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      query,
      params
    );
    console.log(response);
    if (response.error === null) {
      let grandTotal = 0.0;

      let orders = response.data.orderHistory.edges;
      for (let i = 0; i < orders.length; i++) {
        grandTotal = grandTotal + orders[i].node.cart.settlementPrice;
      }
      if (response.data.orderHistory.edges.length === 0)
        this.setState({
          spinnerLoading: false,
          orders: orders,
          grandTotal: grandTotal.toFixed(2),
          loadingValue: "No Rows Found",
          loading: false,
          ordersCount: 0
        });
      else {
        this.setState({
          spinnerLoading: false,
          orders: orders,
          grandTotal: grandTotal.toFixed(2),
          loading: true,
          ordersCount: response.data.orderHistory.totalCount
        });
      }
    } else {
      this.setState({
        spinnerLoading: false,

        loadingValue: "No Rows Found",
        loading: false,
        ordersCount: 0
      });
    }
  };

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
    this.getOrders();
  };

  handleEndDateChange = date => {
    this.setState({
      endDate: date
    });
  };

  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"Orders Booking Date"}</h5>
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"Grand Total= " + this.state.grandTotal}</h5>
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"No of Orders= " + this.state.ordersCount}</h5>
                      </Col>
                    </Row>
                    <Row>
                      <div
                        style={{
                          marginTop: "20",
                          justifyContent: "space-between"
                        }}
                      >
                        <DatePicker
                          selected={this.state.endDate}
                          // maxDate={moment().endOf("day")}
                          dateFormat="DD/MM/YYYY"
                          id="input"
                          readonly
                          onChange={this.handleEndDateChange}
                        />

                        <Button
                          style={{ marginLeft: 20 }}
                          onClick={() => {
                            this.updateOrderBookingDate();
                          }}
                        >
                          Submit
                        </Button>
                      </div>
                    </Row>
                  </Container>
                </CardHeader>
                <Table responsive>
                  <tbody>
                    <tr>
                      <th>Order Id</th>
                      <th>Token</th>
                      <th>status</th>
                      <th>Date/Time</th>
                      <th>Amount</th>
                      <th>Store</th>
                    </tr>
                    {this.state.orders.map(order => {
                      return (
                        <tr
                          key={order.node.id}
                          onClick={() => {
                            this.setState({ selectedOrder: order });
                            // this.toggleModal();
                          }}
                        >
                          <td>{order.node.orderId}</td>
                          <td>{order.node.storeToken}</td>
                          <td>{order.node.status}</td>
                          <td>
                            {moment(order.node.createdAt).format(
                              "MMMM Do YYYY, h:mm a"
                            )}
                          </td>
                          <td>{"₹" + order.node.cart.settlementPrice}</td>
                          <td>{order.node.cart.pickupPoint.store.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }

  updateOrderBookingDate = async () => {
    this.setState({ spinnerLoading: true });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var myHeaders = new Headers();
    var vtimestamp = generateEpochTimestamp();
    myHeaders.append("Authorization", "Token " + authToken);
    let params = {
      store: storeInformation.store.id,
      bookingdate: this.state.endDate.format() + ""
    };
    console.log("PARAMS for booking date", params);

    fetch(config.getHost() + "/product/bookingdate/", {
      method: "POST",
      headers: {
        Authorization: `Token ${authToken}`,
        "Content-Type": "application/json",
        Timestamp: vtimestamp,
        Signature: generateSignature(vtimestamp, authToken)              
      },
      body: JSON.stringify({
        store: storeInformation.store.id,
        bookingdate: this.state.endDate.format() + ""
      })
    })
      .then(res => {
        console.log("Response", res);
        if (res.status === 200) {
          this.setState({ spinnerLoading: false });
          alert("Booking date is added");
          this.getOrders();
        } else {
          this.setState({ spinnerLoading: false });
        }
      })
      .catch(err => {
        this.setState({ spinnerLoading: false });
        console.log("error ", err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/pages/OrderBookingDate/OrderBookingDate.js